export const METADATA_URL = process.env.REACT_APP_METADATA_URL

// check if its vercel enviroment
export const isDevelopment = () => !isStaging() && !isProduction()

export const isStaging = () => process.env.REACT_APP_VERCEL_ENV === 'preview'

export const isProduction = () => process.env.REACT_APP_VERCEL_ENV === 'production'
